import classNames from 'classnames';

import { handleFilesToUpload } from '../../ducks/pages/uploader/thunks';
import type { PickedFile } from '../../ducks/uploader/types';
import { selectCanDropFiles } from '../../panels/uploads/selectors';
import { useLeafRouteParams } from '../../router/use_leaf_route_params';
import { useAppDispatch, useAppSelector } from '../../store/react_redux_typed';
import type { FCC } from '../../types/common';
import FilesDropzone from '../files_dropzone/files_dropzone';

import styles from './main_files_drop_zone.module.css';

type Props = {
  className?: string;
};

const MainFilesDropzone: FCC<Props> = ({ children, className }) => {
  const dispatch = useAppDispatch();
  const { route, params } = useLeafRouteParams();
  const entityId = params.id;
  const versionId = params.versionId;
  const canDropFiles = useAppSelector((state) =>
    selectCanDropFiles(state, entityId, versionId, route),
  );

  return (
    <FilesDropzone
      onDropFiles={(files: PickedFile[]) => {
        dispatch(handleFilesToUpload(files, undefined, undefined, true));
      }}
      disabled={!canDropFiles}
      className={classNames(styles.content, className)}
    >
      {children}
    </FilesDropzone>
  );
};

export default MainFilesDropzone;
